import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_INSURANCES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_INSURANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_INSURANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_INSURANCE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_INSURANCE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
